module.exports = __webpack_public_path__ + "img/PH.21edfa67.svg";